export default __webpack_public_path__ + "static/media/pwaLogo.8bf2293d.webp";